import { __extends } from "../../../config/javascript.js"

Pixlee.module('Controllers', function(Controllers, App, Backbone, Marionette, $) {
    Controllers.Application = (function(_super) {
        __extends(Base, _super);

        function Base(options) {
            if (options == null) {
                options = {};
            }
            this.region = options.region || App.request('default:region');
            this._instance_id = _.uniqueId('controller');
            App.execute('register:instance', this, this._instance_id);
            Base.__super__.constructor.apply(this, arguments);
        }

        Base.prototype.destroy = function() {
            App.execute('unregister:instance', this, this._instance_id);
            return Base.__super__.destroy.apply(this, arguments);
        };

        Base.prototype.show = function(view, options) {
            if (options == null) {
                options = {};
            }
            _.defaults(options, {
                loading: false,
                region: this.region
            });
            this._setMainView(view);
            this._manageView(view, options);
        };
        Base.prototype._setMainView = function(view) {
            if (this._mainView) {
                return;
            }
            this._mainView = view;
            this.listenTo(view, 'destroy', this.destroy);
        };

        Base.prototype._manageView = function(view, options) {
            if (options.loading) {
                App.commands.execute('show:loading', view, options);
            } else {
                options.region.show(view, options);
            }
        };
        return Base;
    })(Marionette.Controller);
});
